import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlights = () => {
  const features = [
    {
      icon: 'Brain',
      title: 'AI-Powered Insights',
      description: 'Get intelligent recommendations and automated categorization for faster accounting'
    },
    {
      icon: 'Zap',
      title: 'Automated Workflows',
      description: 'Streamline invoicing, expense tracking, and reconciliation with smart automation'
    },
    {
      icon: 'BarChart3',
      title: 'Real-Time Reports',
      description: 'Access comprehensive financial reports and analytics whenever you need them'
    },
    {
      icon: 'Shield',
      title: 'Compliance Ready',
      description: 'Stay compliant with automated VAT returns and regulatory requirements'
    },
    {
      icon: 'Clock',
      title: 'Time Tracking',
      description: 'Track project time and manage timesheets with integrated billing capabilities'
    },
    {
      icon: 'Smartphone',
      title: 'Mobile Access',
      description: 'Manage your finances on-the-go with our responsive web application'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-xl font-semibold text-foreground">
          Why Choose AccounTech AI?
        </h3>
        <p className="text-muted-foreground">
          Join thousands of businesses already using our AI-powered accounting platform
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {features?.map((feature, index) => (
          <div key={index} className="p-4 bg-surface border border-border rounded-lg hover:shadow-elevated transition-shadow duration-200">
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={20} className="text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-foreground text-sm mb-1">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground leading-relaxed">{feature?.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Quick Stats */}
      <div className="grid grid-cols-3 gap-4 pt-6 border-t border-border">
        <div className="text-center">
          <div className="text-2xl font-bold text-primary">50K+</div>
          <div className="text-xs text-muted-foreground">Active Users</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-success">99.9%</div>
          <div className="text-xs text-muted-foreground">Uptime</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-accent">24/7</div>
          <div className="text-xs text-muted-foreground">Support</div>
        </div>
      </div>
    </div>
  );
};

export default FeatureHighlights;